export default { sha: '71393dbd56dc2e7e5b104a108189bb27545a48eb', buildNumber: 'undefined' }
